const state = {
    // 菜单
    menu:{
        menuList:[], // 菜单列表
        menuDetailList:[], // 菜单全部信息列表
        isView:false, // 是否折叠菜单
        isAction:'', // 工作台高亮
    },
}
export default state